import { Box, Chip, Divider, Tooltip, Typography } from "@mui/material";
import HeaderBox from "../../../components/shared/boxes/HeaderBox";
import ContainerBox from "../../../components/shared/boxes/ContainerBox";
import InvoiceShowCard from "./InvoiceShowCard";
import InvoiceShowContent from "./InvoiceShowContent";
import { getInvoiceDetails } from "../../api/invoices";
import { useEffect, useState } from "react";
import ErrorBox from "../../../components/shared/boxes/ErrorBox";
import { getInvoiceStatus } from "../../helpers/financialHelpers";
import NFSeEmitError from "./content/Errors/NFSeEmitError";

const InvoiceShowContainer = ({ invoiceId }) => {
    const [invoiceData, setInvoiceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingInstallmentsTable, setLoadingInstallmentsTable] = useState(false);
    const [getInvoiceApiError, setGetInvoiceApiError] = useState(null);
    const [getUpdateValuesApiError, setGetUpdateValuesApiError] = useState(null);
    const [hasNFSeError, setHasNFSeError] = useState(false);

    const errorMessage = getInvoiceApiError || getUpdateValuesApiError;
    const hasError = errorMessage || hasNFSeError;

    useEffect(() => {
        if (!invoiceId) return;

        const loadInvoice = async () => {
            setLoading(true);
            try {
                const data = await getInvoiceDetails(invoiceId);
                setInvoiceData(data);
            } catch (error) {
                setGetInvoiceApiError(error.message);
            } finally {
                setLoading(false);
            }
        };

        loadInvoice();
    }, [invoiceId]);

    useEffect(() => {
        if (!loadingInstallmentsTable) return;

        const fetchUpdatedInvoice = async () => {
            try {
                const updatedInvoice = await getInvoiceDetails(invoiceId);
                setInvoiceData(updatedInvoice);
            } catch (error) {
                setGetUpdateValuesApiError(error.message);
            } finally {
                setLoadingInstallmentsTable(false);
            }
        };

        fetchUpdatedInvoice();
    }, [loadingInstallmentsTable, invoiceId]);

    const invoiceStatus = invoiceData?.status
        ? getInvoiceStatus(invoiceData.status)
        : null;

    return (
        <>
            <Box sx={{ bgcolor: 'background.header' }}>
                <HeaderBox>
                    <Typography variant="h3">Detalhes da fatura</Typography>
                </HeaderBox>
            </Box>
            <Divider />
            <Box sx={{ bgcolor: 'background.default' }}>
                <ContainerBox sx={{ display: 'flex', flexDirection: 'column', gap: '3.25rem' }}>
                    {hasError && (
                        <>
                            {hasNFSeError ? (
                                <NFSeEmitError />
                            ) : (
                                <Box sx={{ mb: '1.25rem' }}>
                                    <ErrorBox
                                        errorMessage={errorMessage}
                                        onClose={() => {
                                            if (getInvoiceApiError) setGetInvoiceApiError(null);
                                            if (getUpdateValuesApiError) setGetUpdateValuesApiError(null);
                                        }}
                                    />
                                </Box>
                            )}
                        </>
                    )}
                    {invoiceStatus && (
                        <Tooltip title={invoiceStatus.description || ''} arrow='right' placement="right">
                            <Chip
                                label={invoiceStatus.label}
                                color={invoiceStatus.color}
                                size="medium"
                                sx={{ alignSelf: 'flex-start' }}
                            />
                        </Tooltip>
                    )}
                    <InvoiceShowCard invoice={invoiceData} loadingInstallmentsTable={loadingInstallmentsTable} />
                    <InvoiceShowContent
                        invoice={invoiceData}
                        setLoadingInstallmentsTable={setLoadingInstallmentsTable}
                        loadingInstallmentsTable={loadingInstallmentsTable}
                        onNFSeErrorChange={setHasNFSeError} />
                </ContainerBox>
            </Box>
        </>
    );
};

export default InvoiceShowContainer;